import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Header from './components/Header';
import AllTab from './containers/AllTab';
import EasyPayTab from './containers/EasyPayTab';
import TransactionsTab from './containers/TransactionsTab';
import { useSearchParams } from 'hooks';
import BuyerTransactionsFilter from '../TransactionsList/components/BuyerTransactionsFilter';
import { useGetCardBuyerTransactionsQuery } from 'services/api/transactions';

type ViewMode = 'full' | 'compact';

const STORAGE_KEY = 'transactionsViewMode';

const isValidViewMode = (v: string | null): v is ViewMode => v === 'full' || v === 'compact';

const TransactionsListV2 = () => {
  const params = useSearchParams();
  const history = useHistory();
  const location = useLocation();
  const currentTab = params.get('active_tab') ?? '';

  const { data: cardCheck } = useGetCardBuyerTransactionsQuery({ limit: 1, offset: 1 });
  const showCardTab = (cardCheck?.count ?? 0) > 0;

  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    const fromUrl = params.get('view');
    if (isValidViewMode(fromUrl)) return fromUrl;
    const fromStorage = localStorage.getItem(STORAGE_KEY);
    if (isValidViewMode(fromStorage)) return fromStorage;
    return 'full';
  });

  const mergeParams = (updates: Record<string, string>) => {
    const current = new URLSearchParams(location.search);
    Object.entries(updates).forEach(([k, v]) => current.set(k, v));
    history.replace({ pathname: location.pathname, search: current.toString() });
  };

  const changeTab = (tab: string) => {
    mergeParams({ active_tab: tab });
  };

  const handleViewChange = (mode: ViewMode) => {
    setViewMode(mode);
    localStorage.setItem(STORAGE_KEY, mode);
    mergeParams({ view: mode });
  };

  return (
    <div>
      <Header currentTab={currentTab} changeTab={changeTab} showCardTab={showCardTab} />
      <div className="pageWrapper">
        <BuyerTransactionsFilter key={currentTab} currentTab={currentTab} viewMode={viewMode} onViewChange={handleViewChange} />
        <div style={{ marginTop: 16 }} />
        {(currentTab === '' || currentTab === 'all') && <AllTab viewMode={viewMode} />}
        {currentTab === 'transactions' && <TransactionsTab viewMode={viewMode} />}
        {currentTab === 'easy_pay' && <EasyPayTab viewMode={viewMode} />}
      </div>
    </div>
  );
};

export default TransactionsListV2;
